export default {
    obiBarcodeSlice(barcode_original){
        let barcode = barcode_original;
        if (barcode.length == 7) {//OBI cimke kézzel beírva
            return barcode;
        }else{
            if(barcode.length <= 13){//termék EAN
                barcode = ('00000000000000' + barcode).slice(-14);
                return barcode;
            }else{//OBI kódcimke
                barcode = barcode.substring(0, 6);
                let mod = 0;
                let sum = 0;
                for (var i = 0; i < 6; i++) {
                    if (i % 2 == 0) {//0,2,4 helyiérték => páratlan ezért eggyel szorzunk
                        mod += parseInt(barcode[i]);
                    } else {//1,3,5 helyiérték => páros 2-vel szorzunk
                        sum = parseInt(barcode[i]) * 2;
                        if (sum >= 10) {
                            mod += 1;
                        }
                        mod += sum % 10;
                    }
                }
                if (mod % 10 == 0) {
                    return barcode + '0';
                } else {
                    return barcode + (10 - (mod % 10)).toString();
                }
            }
        }
    },
    hervisBarcodeSlice(barcode){
        if (barcode.length < 14) {
            return ('0000000000000' + barcode).slice(-13);
        }
        if (barcode.length > 15) {
            return barcode.slice(0, 15);
        }        
        return barcode;
    },
    regularBarcodeSlice(barcode_original){
        let barcode = barcode_original;
        barcode = ('0000000000000' + barcode).slice(-13);
        return barcode;
    },
    placeBarcodeSlice(barcode_original){
        let barcode = barcode_original;
        // eslint-disable-next-line
        const regexPattern = /[^0-9A-Za-z\-\/\\]+/g;
        barcode = barcode.replace(regexPattern, '');
        if (barcode.length == 20) {
            let clean = barcode.substr(11, 8)
            return clean.substr(0, 1) + '-' + clean.substr(1, 3) + '-' + clean.substr(4, 2) + '-' + clean.substr(6, 2);
        }else{
            return barcode;
        }
    }
}